import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PrimarySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PrimarySVG;
